import Api from './Api';

const END_POINT = "inventories";
export default {
  get_material_all(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/material`, request);
  },
  async get_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}/material-list-paginated`, request);
},
  async store(material) {
    console.log(material);
    return await Api.post(`material`, material);
  },
  async update(material) {
    console.log(material);
    return await Api.patch(`/material/${material.id}`, material);
  },
  async delete(material) {
    return await Api.delete(`/material/${material.id}`, material)
  },
  async change_status(material){
    return await Api.patch(`/material/${material.id}/change-status`, material)
  },
  async get_all_categoria(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`categories`, request);
  },
  async get_all_marca(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`brands`, request);
  },
  async get_all_unidadMedida(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`units`, request);
  },
};
